import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SpinnerService } from '../services/spinner/spinner.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private spinner: SpinnerService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let tokenizedReq = request.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionStorage.getItem('HechRomeoToken')}`,
      },
    });

    if (request.url.includes('/platform/export')) {
      tokenizedReq = tokenizedReq.clone({
        responseType: 'arraybuffer'
      });
    }

    if (
      (request.body && request.body['loader']) ||
      (request.params && request.params.get('loader') == 'true')
    ) {
      console.log('showSpinner');
      this.spinner.showSpinner();
    }

    return next.handle(tokenizedReq);
  }
}
